import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { Observable, of } from 'rxjs';

import { IAuroraState } from 'src/app/_apps/aurora.state';
import * as fromRootStore from 'src/app/_apps/root/store';

@Component({
    selector: 'aa-filter-action-circle',
    templateUrl: './filter-action-circle.component.html',
    standalone: false
})
export class FilterActionCircleComponent implements OnInit
{
    filterStatus: Observable<boolean> = of(false);

    constructor (
        private store: Store<IAuroraState>
    )
    {
    }

    ngOnInit ()
    {
        // this.store.dispatch(fromRootStore.RootMiscStoreActions.RootFilterStatusSet({
        //     active: false
        // }));
        this.filterStatus = this.store.select(fromRootStore.getFilterStatus);
    }
}
